import { render, staticRenderFns } from "./kpUserRole.vue?vue&type=template&id=022be4c6&scoped=true"
import script from "./kpUserRole.vue?vue&type=script&lang=js"
export * from "./kpUserRole.vue?vue&type=script&lang=js"
import style0 from "./kpUserRole.vue?vue&type=style&index=0&id=022be4c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022be4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022be4c6')) {
      api.createRecord('022be4c6', component.options)
    } else {
      api.reload('022be4c6', component.options)
    }
    module.hot.accept("./kpUserRole.vue?vue&type=template&id=022be4c6&scoped=true", function () {
      api.rerender('022be4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/kpUserRole.vue"
export default component.exports